import styled from 'styled-components'

export const Container = styled.div`
  padding: 40px;

  p {
    display: block;
    font-size: 25px;
    color: rgb(0, 107, 219);
  }
  h2 {
    display: block;
    margin-bottom: 5px;
    color: rgb(0, 107, 219);
    font-size: 35px;
  }
  .check-email {
    font-size: 15px;
    margin-bottom: 20px; // Adicionado espaço antes do botão
  }
`

export const IconArea = styled.div`
  margin: 30px;
`

export const Button = styled.button`
  padding: 10px 20px;
  background-color: rgb(0, 107, 219);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgb(0, 85, 175);
  }
`
